export const styles = {
  darkScreen: {
    position: "fixed",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.5)",
    zIndex: 1300,
  },
  content: {
    padding: "12px 4px 0",
    overflowY: "auto",
  },
  sidebar: {
    position: "fixed",
    top: 0,
    right: 0,
    // One fixed width (no base-100% / media-1100 swap — that swap is what made
    // the panel flash to full viewport width mid-animation). Slide via transform,
    // which moves the panel by its own width regardless of how wide it is.
    width: "min(1100px, 100%)",
    maxWidth: "100%",
    height: "100vh",
    // Match the sibling Sheet's surface (`bg-background text-foreground`) via the
    // shared tokens so the drawer follows dark mode — the CheckoutContent root is
    // transparent, so a hardcoded white here showed through the gutters and below
    // the "Powered by stripe" footer in dark mode (PAD-31689). #fff in light,
    // #0f172b in dark — light mode is unchanged.
    backgroundColor: "hsl(var(--sds-background))",
    color: "hsl(var(--sds-foreground))",
    boxShadow: "-2px 0 5px rgba(0, 0, 0, 0.2)",
    transform: "translateX(100%)",
    transition: "transform 0.3s ease-in-out",
    willChange: "transform",
    zIndex: 1400,
    overflowY: "auto",
  },
  sidebarOpen: {
    transform: "translateX(0)",
  },
  closeButton: {
    margin: "8px 0",
  },
};
